import { CheckEmailPage } from "@/features/auth";
import { type AuthSearch, validateAuthSearch } from "@/features/auth/auth-search";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/signup/check-email")({
  validateSearch: (search): AuthSearch & { email: string } => ({
    email: typeof search.email === "string" ? search.email : "",
    ...validateAuthSearch(search),
  }),
  component: () => {
    return <CheckEmailPage newUser={true} />;
  },
});
